module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"headline":"Билет на просмотр"},"en":{"headline":"E-ticket"}}')
  delete Component.options._Ctor
}
